import { QRCodeSVG } from 'qrcode.react'
import { cn } from '@/lib/utils'

interface QRCodeViewerProps {
  value: string
  size?: number
  className?: string
  logo?: string
  logoSize?: number
}

export function QRCodeViewer({ value, size = 200, className, logo, logoSize = 40 }: QRCodeViewerProps) {
  if (!value) return null

  return (
    <div className={cn("bg-white p-2 rounded-lg inline-block", className)}>
      <QRCodeSVG
        value={value}
        size={size}
        level="H"
        imageSettings={logo ? {
          src: logo,
          x: undefined,
          y: undefined,
          height: logoSize,
          width: logoSize,
          excavate: true,
        } : undefined}
      />
    </div>
  )
}
